export const findPreviousObject = <T>(arr: T[], obj: T, field: keyof T): T => {
  const index = arr.findIndex((item) => item[field] === obj[field]);
  if (index === -1 || index === 0) {
    return arr[arr.length - 1];
  } else {
    return arr[index - 1];
  }
};
